import React, { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";

import ShowChartIcon from "@material-ui/icons/ShowChart";
import TableChartIcon from "@material-ui/icons/TableChart";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  header: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  actions: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  body: {
    flexGrow: 1,
    minHeight: 0,
  },
  empty: {
    minHeight: 160,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));

// A titled card. When `table` is given, the card gets a chart/table toggle so
// every chart also has a readable, exact-number view.
const ChartCard = ({ title, subtitle, actions, chart, table, isEmpty }) => {
  const classes = useStyles();
  const [view, setView] = useState("chart");

  return (
    <Paper className={classes.paper}>
      <div className={classes.header}>
        <div>
          <Typography variant="h6" component="h2">
            {title}
          </Typography>
          {subtitle && (
            <Typography variant="body2" color="textSecondary">
              {subtitle}
            </Typography>
          )}
        </div>
        <div className={classes.actions}>
          {actions}
          {chart && table && (
            <ToggleButtonGroup
              size="small"
              exclusive
              value={view}
              onChange={(e, value) => value && setView(value)}
              aria-label={`${title} view`}
            >
              <ToggleButton value="chart" aria-label="Chart view">
                <Tooltip title="Chart">
                  <ShowChartIcon fontSize="small" />
                </Tooltip>
              </ToggleButton>
              <ToggleButton value="table" aria-label="Table view">
                <Tooltip title="Table">
                  <TableChartIcon fontSize="small" />
                </Tooltip>
              </ToggleButton>
            </ToggleButtonGroup>
          )}
        </div>
      </div>
      <div className={classes.body}>
        {isEmpty ? (
          <div className={classes.empty}>
            <Typography variant="body2" color="textSecondary">
              No data for this period.
            </Typography>
          </div>
        ) : view === "chart" && chart ? (
          chart
        ) : (
          table
        )}
      </div>
    </Paper>
  );
};

export default ChartCard;
